import { RequestFormController } from './request-form.controller'

function requestForm () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/directives/request-form/request-form-directive.html?$$REVISION$$',
    controller: RequestFormController
  }
}

export { requestForm }
